/* src/app/layout/footer/footer.component.scss */
.footer {
  position: absolute;
  padding: 0 4rem;
}
.fcdl-footer-background {
  height: 0 !important;
}
/*# sourceMappingURL=footer.component-IZ3PW2UG.css.map */
